/**
 * Мінімум контексту списку, якого вистачає перевірці.
 *
 * Навмисно не `ICrudResourceContext`: інстансний `accessFn` отримує контекст
 * як `any`, і тягнути сюди повний контракт ядра заради двох полів зайве.
 */
interface PageAccessContext {
    contextType?: string
    resource?: {
        pageConfig?: {
            accessFn?: (options: { context: unknown }) => boolean
        }
    }
}

/**
 * Чи відкривати сторінку ресурсу — за `pageConfig.accessFn` самого ресурсу.
 *
 * Ядро генерує маршрути ресурсів (`/settings/client-statuses`) без
 * `pageConfig`: функцію доступу маршрут не отримує, і сторінка відкривається
 * будь-кому, хто має право читати колекцію. Для довідників цього мало —
 * читає їх кожен (селекти карток), а сторінку бачить лише адміністратор
 * (`SPEC-007` §7.1). Тому інстансний `accessFn` (`CrudResourceConfig`) питає
 * тут `pageConfig.accessFn` ресурсу, коли малює список.
 *
 * Лише список (`contextType === 'list'`): картки й селекти того самого ресурсу
 * з інших екранів перевіряються своїми правами, а не правом на сторінку.
 * Ресурс без `pageConfig.accessFn` — без обмежень.
 */
export const CheckResourcePageAccessTask = (crudContext?: PageAccessContext | null): boolean => {
    if (crudContext?.contextType !== 'list') return true

    const accessFn = crudContext.resource?.pageConfig?.accessFn

    if (typeof accessFn !== 'function') return true

    return accessFn({ context: crudContext }) !== false
}
